var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 1024.000000 908.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,908.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1060 8489 c-298 -78 -518 -313 -576 -616 -21 -111 -21 -6104 0 -6215 54 -282 246 -502 524 -602 l87 -31 4035 -3 c4015 -2 4035 -2 4115 18 296 75 518 306 579 602 14 69 16 383 16 3127 0 2674 -2 3058 -15 3121 -61 291 -290 528 -579 600 -78 20 -124 20 -4095 19 -3954 0 -4017 0 -4091 -20z m8076 -624 c28 -16 49 -39 63 -68 l21 -43 0 -2991 0 -2990 -23 -43 c-16 -30 -37 -51 -67 -67 l-43 -23 -3929 0 c-3314 0 -3934 2 -3961 14 -48 20 -88 69 -98 118 -11 56 -11 5930 0 5986 9 48 49 97 96 118 25 11 699 13 3964 14 l3934 0 43 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2470 7246 c-193 -43 -374 -145 -499 -282 -108 -118 -181 -250 -222 -404 -32 -119 -33 -346 0 -465 74 -274 260 -496 515 -616 351 -164 772 -92 1047 180 120 120 196 246 246 408 24 80 27 103 27 253 1 131 -3 179 -18 234 -95 352 -373 619 -718 690 -91 19 -297 20 -378 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5308 5233 l-1248 -1248 -390 390 -390 390 -780 -780 -780 -780 0 -467 0 -468 3435 0 3435 0 0 1093 0 1092 -1013 1013 c-556 556 -1014 1012 -1017 1012 -3 0 -566 -561 -1252 -1247z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.1e93bff56ec0104a93dc4550fdcf1eba.svg";
export { ForwardRef as ReactComponent };